"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var getFormatDateNow = function () { return moment_1.default().format("MM/DD/YYYY"); };
exports.getFormatDateNow = getFormatDateNow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9oZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMkI7QUFFM0IsSUFBTSxnQkFBZ0IsR0FBRyxjQUFNLE9BQUEsZ0JBQU0sRUFBRSxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsRUFBN0IsQ0FBNkIsQ0FBQTtBQUVwRCw0Q0FBZ0IifQ==